import { methods, ServiceMaker } from './index';

const { POST } = methods;

export const walletupdate = data => ServiceMaker(`v1/api/customer/walletupdate`, POST, null, data);

export const Osdmessage = data => ServiceMaker(`v1/api/osd/sendmessage`, POST, null, data);